import { render, staticRenderFns } from "./EquipmentInfo.vue?vue&type=template&id=2d79a660"
import script from "./EquipmentInfo.vue?vue&type=script&lang=js"
export * from "./EquipmentInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports